export const PASSWORD_STATE_STRONG_KEY = 'strong'
export const PASSWORD_STATE_NORMAL_KEY = 'normal'
export const PASSWORD_STATE_WEAK_KEY = 'weak'


export const PASSWORD_STATE_STRONG_PROGRESS_BAR_COLOR = 'icon-success'
export const PASSWORD_STATE_NORMAL_PROGRESS_BAR_COLOR = 'icon-warning'
export const PASSWORD_STATE_WEAK_PROGRESS_BAR_COLOR = 'icon-error'

export const PASSWORD_STATE_STRONG_PROGRESS_TEXT_COLOR = 'text-success'
export const PASSWORD_STATE_NORMAL_PROGRESS_TEXT_COLOR = 'text-warning'
export const PASSWORD_STATE_WEAK_PROGRESS_TEXT_COLOR = 'text-error'